import React from "react";
import Router from "routing/Router";
import "./assets/styles/index.sass";
import { ToastContainer } from "react-toastify";
import * as Sentry from "@sentry/react";
import ErrorHasOccurred, { chunkErrors } from "components/ErrorHasOccured";
import FullScreenLoader from "components/FullScreenLoader";

const env = import.meta.env.MODE;

if (env === "production") {
    Sentry.init({
        dsn: "https://ec7792a91c1246437fd2e09282461089@o80526.ingest.us.sentry.io/4508517765218304",
        environment: env,
        ignoreErrors: [
            ...chunkErrors,
            "Load failed",
            "Illegal invocation",
            "No error message",
            "NetworkError when attempting to fetch resource.",
            "Failed to fetch",
            "ResizeObserver loop completed with undelivered notifications.",
            'Permission denied to access property "nodeType"', // TinyMCE error.
            "Non-Error promise rejection captured with value: Object Not Found Matching Id:",
            "Object captured as exception with keys: message", // Some err related to not being able to load hubspot js
        ],
    });
}

function App() {
    return (
        <Sentry.ErrorBoundary fallback={ErrorHasOccurred}>
            <React.Suspense fallback={<FullScreenLoader/>}>
                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    closeOnClick
                    draggable
                    pauseOnHover
                    closeButton
                />
                <Router/>
            </React.Suspense>
        </Sentry.ErrorBoundary>
    );
}

export default App;
